
import React from 'react';
import { FaIcon } from '../../../index.js';
import PropTypes from 'prop-types';

var NavLink = function NavLink(_ref) {
    var icon = _ref.icon,
        name = _ref.name,
        classNames = _ref.classNames;

    return React.createElement(
        'div',
        { className: 'side-navigation-nav-link mb-2 py-3 rounded-circle ' + classNames },
        React.createElement(FaIcon, { size: 'x', icon: icon }),
        React.createElement(
            'span',
            { className: 'fs-50 d-block mt-2' },
            name
        )
    );
};

NavLink.defaultProps = {
    classNames: "",
    icon: "bicycle",
    name: "Button"
};
NavLink.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
    * Name
    */
    name: PropTypes.string,
    /**
     * Link
     */
    link: PropTypes.string,
    /**
    * Active Navigation
    */
    classNames: PropTypes.string
} : {};
export default NavLink;